import React from 'react'
import {Card, Divider, List, Typography, theme} from 'antd'
import {ToDo} from '../../entities/todoList'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {getToDoTypeInfo} from '../../entities/journalRecord'
import '../home/news.less'
import {CalendarOutlined, RightOutlined} from '@ant-design/icons'

export type Reminders = {
  todos: ToDo[]
  plantedPlantsNamesWithId?: {id: number; name: string}[]
}

export function Reminders({todos, plantedPlantsNamesWithId = []}: Reminders) {
  const {token} = theme.useToken()
  const intl = useIntl()

  return (
    <Card
      className="news-page__list__card"
      style={{width: '100%'}}
      title={intl.formatMessage({id: 'reminders'})}
      styles={{
        header: {borderBottom: '1px solid #f0f0f0'},
        body: {paddingTop: 16},
      }}
      cover={<div className="news-page__list__card__orange-stripe" />}
    >
      <List
        // style={{width: '100%'}}
        // header={
        //   <Typography.Text color={'red'} strong>
        //     {intl.formatMessage({id: 'reminders'})}
        //   </Typography.Text>
        // }
        // footer={
        //   <Link to="/todos">
        //     {todos.length >= 1
        //       ? intl.formatMessage({id: 'seeAllReminders'})
        //       : intl.formatMessage({id: 'createFirstTask'})}
        //   </Link>
        // }
        //bordered
        dataSource={todos.length > 5 ? todos.slice(0, 5) : todos}
        renderItem={(item) => (
          <List.Item>
            <div style={{flexDirection: 'column'}}>
              <div style={{flexDirection: 'row'}}>
                <span>
                  {getToDoTypeInfo(item.type).icon}
                  {item.type.type === 'custom' || !item.type.type
                    ? getToDoTypeInfo(item.type).name
                    : intl.formatMessage({id: `eventType-${getToDoTypeInfo(item.type).name}`})}
                </span>
                {item.plants.length > 0 && (
                  <span style={{color: '#f58153'}}>
                    {`: `}
                    {item.plants.map((plant, index) =>
                      index === 0 ? plant.name : `, ${plant.name}`
                    )}
                  </span>
                )}
              </div>
              <div>
                <span className="news-list-page__list__news__calendar">
                  <CalendarOutlined />
                  <span className="news-list-page__list__news__calendar__text">
                    {item.targetEndDateUtc
                      ? `${item.targetStartDateUtc}-${item.targetEndDateUtc}`
                      : item.targetStartDateUtc}
                  </span>
                </span>
              </div>
            </div>
          </List.Item>
        )}
      />
      <Divider style={{margin: '12px 0'}} />

      <a className="news-page__list__card__to-all" href="/todos">
        {todos.length >= 1
          ? intl.formatMessage({id: 'allPlannedTasks'})
          : intl.formatMessage({id: 'createFirstTask'})}
        <RightOutlined style={{paddingLeft: '5px'}} />
      </a>
    </Card>
  )
}
